import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useStatisticsBiennialMonthlyWaterConsumption(
  year,
  month,
  params,
  options,
  key = "getMonthlyWaterConsumptionData",
) {
  const axiosPrivate = useAxiosPrivate();

  const getBiennialMonthlyWaterConsumptionData = async () => {
    const { data } = await axiosPrivate({
      method: "GET",
      url: `WaterConsumption/Biennial/${year}/${month}`,
      params,
    });

    return data;
  };

  return useQuery(
    [key],
    () => getBiennialMonthlyWaterConsumptionData(year, month, params),
    {
      ...options,
    },
  );
}

export default useStatisticsBiennialMonthlyWaterConsumption;
